var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgProjectDevices(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 16,
    viewBox: "0 0 15 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.7746 1.35211H4.22535C2.59183 1.35211 1.2676 2.76462 1.2676 4.50704V11.493C1.2676 13.2354 2.59183 14.6479 4.22535 14.6479H12.8873C13.354 14.6479 13.7324 14.2443 13.7324 13.7465V4.50704C13.7324 2.76462 12.4082 1.35211 10.7746 1.35211ZM4.22535 0C1.89175 0 0 2.01787 0 4.50704V11.493C0 13.9821 1.89175 16 4.22535 16H12.8873C14.0541 16 15 14.9911 15 13.7465V4.50704C15 2.01787 13.1082 0 10.7746 0H4.22535Z",
    fill: "#424242",
    fillOpacity: 0.8
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.5 11.7183C9.36688 11.7183 10.8803 10.104 10.8803 8.11268C10.8803 6.12134 9.36688 4.50704 7.5 4.50704C5.63313 4.50704 4.11972 6.12134 4.11972 8.11268C4.11972 10.104 5.63313 11.7183 7.5 11.7183ZM7.5 10.5915C8.78347 10.5915 9.82394 9.48172 9.82394 8.11268C9.82394 6.74363 8.78347 5.6338 7.5 5.6338C6.21654 5.6338 5.17606 6.74363 5.17606 8.11268C5.17606 9.48172 6.21654 10.5915 7.5 10.5915Z",
    fill: "#424242",
    fillOpacity: 0.8
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProjectDevices);
export default __webpack_public_path__ + "static/media/projectDevices.74ddaefb688e5500ebcbb4a87dbd0f58.svg";
export { ForwardRef as ReactComponent };